import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var Building2Icon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsxs("g", {
                            clipPath: "url(#building-2__a)",
                            children: [
                                _jsx("path", {
                                    d: "M22.59 9.37c-.49-.49-1.14-.76-1.83-.76h-3.78V3.24c0-.69-.27-1.34-.76-1.83-.48-.48-1.15-.76-1.83-.76H3.24c-.69 0-1.34.27-1.83.76S.65 2.55.65 3.24v19.11c0 .55.45 1 1 1h20.7c.55 0 1-.45 1-1V11.21c0-.69-.27-1.34-.76-1.83v-.01zM9.81 21.35H7.83v-2.78h1.98v2.78zm5.17 0h-3.17v-2.98a1.81 1.81 0 00-1.8-1.8H7.62c-.47 0-.94.19-1.27.53-.34.34-.53.79-.53 1.27v2.98H2.65V3.24c0-.16.06-.31.17-.42a.59.59 0 01.42-.17h11.15c.16 0 .31.06.42.17.11.11.17.26.17.42v18.11zm6.37 0h-4.37V10.61h3.78c.16 0 .31.06.42.17.11.11.17.26.17.42v10.15z"
                                }),
                                _jsx("path", {
                                    d: "M6.43 4.63c-.55 0-1 .45-1 1v1.59c0 .55.45 1 1 1s1-.45 1-1V5.63c0-.55-.45-1-1-1zm4.77 0c-.55 0-1 .45-1 1v1.59c0 .55.45 1 1 1s1-.45 1-1V5.63c0-.55-.45-1-1-1zM6.43 10.2c-.55 0-1 .45-1 1v1.59c0 .55.45 1 1 1s1-.45 1-1V11.2c0-.55-.45-1-1-1zm4.77 0c-.55 0-1 .45-1 1v1.59c0 .55.45 1 1 1s1-.45 1-1V11.2c0-.55-.45-1-1-1z"
                                })
                            ]
                        }),
                        _jsx("defs", {
                            children: _jsx("clipPath", {
                                id: "building-2__a",
                                children: _jsx("path", {
                                    d: "M0 0h24v24H0z"
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
Building2Icon.isCarinaIcon = true;
export default Building2Icon;
